/*
  饼干印章 · 实时压印预览（配合 sections/lf-bx-preview.liquid，算法照搬 Fil & Nous 的 fn-biscuit-preview.js）
  - 顾客第一次在 PatchStitch 定制框里输入或选款式时，把预览叠到商品第 1 张图上，并把图库切到第 1 张
  - 手机上图库在页面上方，输入时右上角浮出小预览，停止输入几秒后收起
  - 定制项按标题对应（去掉变音符、大小写和必填星号后比较）；Loomina 里改了标题，这里要同步改
  - 坐标都是商品主图 1045×1506 像素坐标：底图 assets/lf-biscuit-base-<key>.jpg 和第 1 张图逐像素对齐，换主图时要一起换底图
  - 底图在顾客第一次点进定制框时才开始下载，不拖慢页面首屏
*/
(function () {
  'use strict';
  var SVGNS = 'http://www.w3.org/2000/svg';
  var W = 1045, H = 1506;

  function words(v) { return v.trim().split(/\s+/).filter(Boolean); }

  /* 按商品 ID 配置。fields：key → 定制项标题（可多个，兼容改名前后）+ 没输入时显示的默认文字
     ui：只在 Liebefunk 生效的德语文案覆盖（按定制项标题开头匹配）——ph 占位文字、ideas 推荐写法按钮、tip 提示。
     Loomina 里这些定制项和 Fil & Nous 共用法语原文，发布到德语店时自动翻译，译文常超过字数上限，所以在这里改，不动 Loomina */
  var PRODUCTS = {
    /* Tannenbaum：上下两段弧形文字，中间的树和星星在底图上 */
    '15462789578937': { base: 'tanne',
      fields: { oben: { titles: ['text oben'], def: 'FROHES FEST' },
                unten: { titles: ['text unten'], def: 'Familie Müller' } },
      ui: { 'text oben': { ph: 'FROHES FEST', ideas: ['FROHES FEST', 'FROHE FESTTAGE', 'FROHE WEIHNACHT', 'PLÄTZCHENZEIT'] },
            'text unten': { tip: 'Der Text wird genau so graviert, wie du ihn eingibst – inklusive Groß- und Kleinschreibung.' } },
      draw: function (v, s) {
        s.arc(v.oben, { cx: 540, cy: 800, r: 288, side: 'top', maxW: 600 }, { font: 'Montserrat', weight: 700, size: 80, ls: 2, caps: true });
        s.arc(v.unten, { cx: 540, cy: 786, r: 290, side: 'bottom', maxW: 600 }, { font: 'Montserrat', weight: 700, size: 80, ls: 2 });
      } },
    /* Die Familie（2026-10-27 换了新首图）：问候语一段弧形粗体大写，名字用手写体分两行，冬青在底图上。
       底图和首图不是逐像素对齐的：坐标按底图里的饼干量（圆心 527,761，半径 408） */
    '15462780960953': { base: 'familie',
      fields: { msg: { titles: ['personalisierte nachricht'], def: 'FROHE WEIHNACHT' },
                nom: { titles: ['familienname'], def: 'Familie Müller' } },
      ui: { 'personalisierte nachricht': { ph: 'FROHE WEIHNACHT', ideas: ['FROHE WEIHNACHT', 'FROHES FEST', 'FROHE FESTTAGE', 'SÜSSE GRÜSSE'] },
            'familienname': { ph: 'Familie Müller', tip: 'Gib den vollständigen Text ein, er wird genau so graviert. Bsp.: „Familie Müller“ und nicht nur „Müller“.' } },
      draw: function (v, s) {
        s.arc(v.msg, { cx: 532, cy: 790, r: 308, side: 'top', maxW: 720 }, { font: 'Roboto Condensed', weight: 800, size: 112, ls: 1, caps: true });
        var n = words(v.nom);
        var lines = n.length > 1 ? [n.slice(0, -1).join(' '), n[n.length - 1]] : n;
        var L = lines.length > 1 ? [[518, 750, 220, 445], [530, 914, 175, 470]] : [[525, 845, 220, 480]];
        lines.forEach(function (t, i) { s.text(t, { x: L[i][0], y: L[i][1], size: L[i][2], maxW: L[i][3], font: 'Playball' }); });
      } },
    /* Familienstempel：「Frohe Weihnachten」和花环在底图上；顾客文字超过两个词时分两行（前面的词 / 最后两个词） */
    '15462781026489': { base: 'stempel',
      fields: { nom: { titles: ['familienname'], def: 'Familie Müller' } },
      ui: { 'familienname': { tip: 'Dein Text wird genau so unter „Frohe Weihnachten“ graviert, wie du ihn eingibst. Beispiel: „wünscht Familie Müller“ oder „Familie Müller“.' } },
      draw: function (v, s) {
        var rot = [-3.5, 735, 980];
        var w = words(v.nom);
        var lines = w.length > 2 ? [w.slice(0, -2).join(' '), w.slice(-2).join(' ')] : [w.join(' ')];
        var L = lines.length > 1 ? [[720, 955, 48, 240], [732, 1007, 47, 360]] : [[730, 988, 52, 360]];
        lines.forEach(function (t, i) { s.text(t, { x: L[i][0], y: L[i][1], size: L[i][2], maxW: L[i][3], font: 'Libre Baskerville', rotate: rot }); });
      } },
    /* Unser erstes Weihnachten：上方弧形 + 「Weihnachten」下一行 + 婚戒两侧的两个名字 + 底部年份 */
    '15462780928185': { base: 'ehepaar',
      fields: { oben: { titles: ['text oben'], def: 'UNSER ERSTES' },
                unter: { titles: ['text unter'], def: '' },
                p1: { titles: ['vorname 1'], def: 'ANNA' },
                p2: { titles: ['vorname 2'], def: 'LUKAS' },
                unten: { titles: ['text unten'], def: '' } },
      ui: { 'text oben': { tip: 'Wird im Bogen über „Weihnachten“ graviert – genau so, wie du ihn eingibst, inklusive Großschreibung.', ideas: ['UNSER ERSTES', 'UNSER ZWEITES', 'UNSER FÜNFTES', 'UNSER ZEHNTES'] },
            'text unter': { ph: 'ALS EHEPAAR', ideas: ['ALS EHEPAAR', 'ZUSAMMEN', 'ALS FAMILIE'] },
            'vorname 1': { ph: 'ANNA' },
            'vorname 2': { ph: 'LUKAS' } },
      draw: function (v, s) {
        var f = { font: 'Libre Baskerville', weight: 700 };
        /* 原图这段弧形字整体偏右，绕圆心顺时针转约 6.6° */
        s.arc(v.oben, { cx: 561, cy: 907, r: 339, side: 'top', maxW: 430, rotate: 6.6 }, { font: f.font, weight: 700, size: 52 });
        if (v.unter.trim()) s.text(v.unter, { x: 584, y: 905, size: 74, maxW: 500, font: f.font, weight: 700, ls: 1 });
        /* 名字和年份在原图里是窄字形：横向压到 85 % */
        s.text(v.p1, { x: 418, y: 986, size: 54, sx: 0.85, maxW: 170, font: f.font, weight: 700 });
        s.text(v.p2, { x: 728, y: 988, size: 54, sx: 0.85, maxW: 190, font: f.font, weight: 700 });
        if (v.unten.trim()) s.text(v.unten, { x: 567, y: 1066, size: 58, sx: 0.88, maxW: 260, font: f.font, weight: 700 });
      } },
    /* Lebkuchen：名字只写在选中的那个小人身上 */
    '15462780993721': { base: 'lebkuchen',
      fields: { modell: { titles: ['lebkuchenmann-motiv'], choice: true, def: 'Junge' },
                name: { titles: ['vorname'], def: '' } },
      ui: { 'vorname': { ph: 'Lukas', tip: 'Der Vorname wird genau so graviert, wie du ihn schreibst – inklusive Großbuchstaben.' } },
      draw: function (v, s) {
        /* 没填名字时显示首图上的名字：男孩 LUKAS、女孩 ANNA */
        var girl = /m(a|ä)dchen/i.test(v.modell);
        if (!v.name.trim()) v.name = girl ? 'ANNA' : 'LUKAS';
        if (girl) s.text(v.name, { x: 775, y: 828, size: 63, maxW: 220, font: 'Montserrat', weight: 700, ls: 1 });
        else s.text(v.name, { x: 298, y: 789, size: 67, maxW: 240, font: 'Montserrat', weight: 700, ls: 1 });
      } }
  };

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[*’'„“"]/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function el(tag, attrs, parent) {
    var e = document.createElementNS(SVGNS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }

  /* 共用的压印滤镜：凹槽颜色在 Fil & Nous 的取样值上略调深，按 Liebefunk 主图比对过 */
  function filters() {
    if (document.getElementById('lf-bp-groove')) return;
    var svg = el('svg', { width: 0, height: 0, 'aria-hidden': 'true', style: 'position:absolute' });
    svg.innerHTML =
      '<defs>' +
      '<filter id="lf-bp-groove" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">' +
        '<feMorphology in="SourceAlpha" operator="dilate" radius=".6" result="a"/>' +
        '<feFlood flood-color="rgb(196,138,56)"/><feComposite in2="a" operator="in" result="floor"/>' +
        '<feGaussianBlur in="a" stdDeviation="2.4" result="blur"/><feOffset in="blur" dx="3" dy="5" result="shift"/>' +
        '<feComposite in="a" in2="shift" operator="out" result="wall"/><feGaussianBlur in="wall" stdDeviation=".8" result="wallSoft"/>' +
        '<feFlood flood-color="rgb(146,88,18)"/><feComposite in2="wallSoft" operator="in" result="shade"/>' +
        '<feMerge result="m"><feMergeNode in="floor"/><feMergeNode in="shade"/></feMerge><feGaussianBlur in="m" stdDeviation=".4"/>' +
      '</filter>' +
      '<filter id="lf-bp-lip" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">' +
        '<feOffset in="SourceAlpha" dx="2" dy="4" result="down"/><feComposite in="down" in2="SourceAlpha" operator="out" result="rim"/>' +
        '<feGaussianBlur in="rim" stdDeviation="1.6" result="rimSoft"/><feFlood flood-color="rgb(150,130,110)"/><feComposite in2="rimSoft" operator="in"/>' +
      '</filter></defs>';
    document.body.appendChild(svg);
  }

  /* 一个画面：底图 + 两层引用同一组文字的压印（正片叠底压暗 + 滤色提亮）。typeId：被引用的文字层 id */
  function scene(typeId) {
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, 'aria-hidden': 'true' });
    var image = el('image', { width: W, height: H }, svg);
    el('use', { href: '#' + typeId, filter: 'url(#lf-bp-groove)', style: 'mix-blend-mode:multiply' }, svg);
    el('use', { href: '#' + typeId, filter: 'url(#lf-bp-lip)', style: 'mix-blend-mode:screen' }, svg);
    return { svg: svg, image: image };
  }

  /* 排版器：文字画进不可见的测量层 type，弧线路径放进 defs；两层压印用 <use> 引用 type */
  function painter(type, defs) {
    var n = 0;
    function fit(t, size, maxW) {
      t.setAttribute('font-size', size);
      var w = t.getComputedTextLength();
      if (w <= maxW) return;
      t.setAttribute('font-size', Math.max(size * 0.45, size * maxW / w).toFixed(1));
      if (t.getComputedTextLength() > maxW) { t.setAttribute('textLength', maxW); t.setAttribute('lengthAdjust', 'spacingAndGlyphs'); }
    }
    function arcD(a) {
      var s = 80 * Math.PI / 180, r = a.r, dx = r * Math.sin(s), dy = r * Math.cos(s);
      if (a.side === 'top') return 'M' + (a.cx - dx) + ' ' + (a.cy - dy) + ' A' + r + ' ' + r + ' 0 0 1 ' + (a.cx + dx) + ' ' + (a.cy - dy);
      return 'M' + (a.cx - dx) + ' ' + (a.cy + dy) + ' A' + r + ' ' + r + ' 0 0 0 ' + (a.cx + dx) + ' ' + (a.cy + dy);
    }
    return {
      reset: function () { type.textContent = ''; defs.textContent = ''; n = 0; },
      text: function (str, o) {
        if (!str.trim()) return;
        var t = el('text', { x: o.x, y: o.y, 'text-anchor': 'middle', 'font-family': o.font, 'font-weight': o.weight || 400, 'letter-spacing': o.ls || 0 }, type);
        /* stroke：给细字体加粗（压印滤镜只看文字轮廓，描边颜色无所谓） */
        if (o.stroke) { t.setAttribute('stroke', '#000'); t.setAttribute('stroke-width', o.stroke); t.setAttribute('stroke-linejoin', 'round'); }
        var tf = o.rotate ? 'rotate(' + o.rotate.join(' ') + ')' : '';
        /* sx：以 x 为中心横向压缩（maxW 指压缩后的宽度） */
        if (o.sx) tf += ' translate(' + o.x + ' 0) scale(' + o.sx + ' 1) translate(' + (-o.x) + ' 0)';
        if (tf) t.setAttribute('transform', tf);
        t.textContent = o.caps ? str.toUpperCase() : str;
        fit(t, o.size, o.maxW / (o.sx || 1));
      },
      arc: function (str, a, o) {
        if (!str.trim()) return;
        var id = type.id + '-arc' + (n++);
        el('path', { id: id, d: arcD(a), fill: 'none' }, defs);
        var t = el('text', { 'font-family': o.font, 'font-weight': o.weight || 400, 'letter-spacing': o.ls || 0 }, type);
        if (a.rotate) t.setAttribute('transform', 'rotate(' + a.rotate + ' ' + a.cx + ' ' + a.cy + ')');
        var tp = el('textPath', { href: '#' + id, startOffset: '50%', 'text-anchor': 'middle' }, t);
        tp.textContent = o.caps ? str.toUpperCase() : str;
        fit(t, o.size, a.maxW);
      }
    };
  }

  /* 在一个画面里搭好测量层，返回排版器（商品页和本地比对页共用） */
  function stage(sc, typeId) {
    var hold = el('g', { opacity: 0 }, sc.svg);
    var type = el('g', { id: typeId }, hold);
    var defs = el('defs', {}, sc.svg);
    return painter(type, defs);
  }

  function boot(host) {
    var cfg = PRODUCTS[host.getAttribute('data-product-id')];
    if (!cfg) return;
    var imgs = JSON.parse(host.querySelector('[data-lf-bp-imgs]').textContent);
    var url = imgs[cfg.base];
    var first = (host.getAttribute('data-first-image') || '').split('?')[0].split('/').pop().replace(/\.[a-z]+$/i, '');
    filters();

    /* 大图：叠在第 1 张商品图上（找 src 里含主图文件名的那一格，图库被重绘后会重新挂上） */
    var wrap = document.createElement('div'); wrap.className = 'lf-bp';
    var big = scene('lf-bp-type');
    var paint = stage(big, 'lf-bp-type');
    wrap.appendChild(big.svg);
    wrap.insertAdjacentHTML('beforeend', '<span class="lf-bp__badge"><i></i></span><span class="lf-bp__note"></span>');
    wrap.querySelector('.lf-bp__badge').appendChild(document.createTextNode(host.getAttribute('data-label') || ''));
    wrap.querySelector('.lf-bp__note').textContent = host.getAttribute('data-note') || '';

    function slide() {
      var slides = document.querySelectorAll('media-gallery slideshow-slide.product-media-container');
      for (var i = 0; i < slides.length; i++) {
        var im = slides[i].querySelector('img');
        if (im && first && (im.currentSrc || im.src || '').indexOf(first) !== -1) return slides[i];
      }
      return slides[0] || null;
    }
    function mount() {
      var sl = slide(); if (!sl) return null;
      var media = sl.querySelector('.product-media') || sl;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      if (wrap.parentNode !== media) {
        media.appendChild(wrap);
        var im = media.querySelector('img');
        if (im) { place(im); if (window.ResizeObserver) new ResizeObserver(function () { place(im); }).observe(im); }
      }
      return sl;
    }
    /* 主图在格子里不一定铺满：预览层占同一个盒子，复制图片的缩放 / 位移（主题给图片加了 scale: 0.9），
       盒子里再按 object-fit: contain 的方式留边 */
    function place(im) {
      var bw = im.offsetWidth, bh = im.offsetHeight;
      if (!bw || !bh) return;
      var cs = getComputedStyle(im);
      var cw = bw, ch = bw * H / W;
      if (ch > bh) { ch = bh; cw = bh * W / H; }
      var l = im.offsetLeft + (bw - cw) / 2, t = im.offsetTop + (bh - ch) / 2;
      /* 变换原点换算到预览层自己的坐标里，缩放后才会和图片重合 */
      var o = cs.transformOrigin.split(' ').map(parseFloat);
      wrap.style.cssText = 'inset:auto;left:' + l + 'px;top:' + t + 'px;width:' + cw + 'px;height:' + ch + 'px;' +
        'scale:' + cs.scale + ';translate:' + cs.translate + ';transform:' + cs.transform + ';' +
        'transform-origin:' + (im.offsetLeft + o[0] - l) + 'px ' + (im.offsetTop + o[1] - t) + 'px';
    }

    /* 小图：手机上输入时浮在右上角 */
    var mini = document.createElement('div'); mini.className = 'lf-bp-mini';
    var small = scene('lf-bp-type');
    mini.appendChild(small.svg); document.body.appendChild(mini);

    /* 底图下载完才显示预览：没下载完时新文字会叠在原图的旧文字上，出现重影 */
    var loaded = false, ready = false;
    function load() {
      if (loaded) return; loaded = true;
      var pre = new Image();
      pre.onload = function () {
        big.image.setAttribute('href', url); small.image.setAttribute('href', url);
        ready = true;
        if (started) wrap.classList.add('is-on');
      };
      pre.src = url;
    }

    var values = {};
    function titleOf(opt) {
      var t = opt.querySelector('.ps-option__title');
      return norm(t && t.firstChild ? t.firstChild.textContent : '');
    }
    function matches(f, title) { return f.titles.some(function (x) { return title === x || title.indexOf(x) === 0; }); }
    function read() {
      var root = document.querySelector('[data-patchstitch-root]');
      Object.keys(cfg.fields).forEach(function (k) { values[k] = cfg.fields[k].def; });
      if (!root) return;
      root.querySelectorAll('.ps-option').forEach(function (opt) {
        var title = titleOf(opt);
        Object.keys(cfg.fields).forEach(function (k) {
          var f = cfg.fields[k];
          if (!matches(f, title)) return;
          if (f.choice) {
            var c = opt.querySelector('.ps-choice[data-selected="true"]');
            var im = c && c.querySelector('img');
            if (c) values[k] = c.getAttribute('title') || (im && im.getAttribute('alt')) || '';
          } else {
            var inp = opt.querySelector('.ps-text-input, textarea');
            if (inp && inp.value.trim()) values[k] = inp.value;
          }
        });
      });
    }
    function draw() {
      read(); paint.reset(); cfg.draw(values, paint);
    }

    var started = false, hideT;
    function visible(sl) {
      var r = sl.getBoundingClientRect();
      return r.bottom > 80 && r.top < window.innerHeight - 80 && r.left >= -10 && r.right <= window.innerWidth + 10;
    }
    function touched() {
      load(); draw();
      var sl = mount();
      var im0 = wrap.parentNode && wrap.parentNode.querySelector('img');
      if (im0) place(im0);
      if (!started) {
        started = true; if (ready) wrap.classList.add('is-on');
        /* 图库切到第 1 张（点缩略图会触发主题自己的切换逻辑） */
        var th = document.querySelector('media-gallery .slideshow-controls__thumbnail');
        if (th && th.getAttribute('aria-selected') !== 'true') th.click();
      }
      if (sl && !visible(sl)) {
        var hd = document.querySelector('header-component, .header-section, #header-group');
        mini.style.top = Math.max(10, (hd ? hd.getBoundingClientRect().bottom : 0) + 10) + 'px';
        mini.classList.add('is-on'); clearTimeout(hideT); hideT = setTimeout(function () { mini.classList.remove('is-on'); }, 2500);
      } else mini.classList.remove('is-on');
    }

    /* PatchStitch 每次输入都会重建选项 DOM，冒泡到 document 时输入框可能已经不在页面上：
       用捕获阶段判断来源，等它重建完再读值 */
    document.addEventListener('focusin', function (e) {
      if (e.target.closest && e.target.closest('[data-patchstitch-root]')) load();
    }, true);
    document.addEventListener('input', function (e) {
      if (e.target.closest && e.target.closest('[data-patchstitch-root]')) setTimeout(touched, 0);
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-patchstitch-root] .ps-choice')) setTimeout(touched, 0);
    }, true);
    /* 换款式时 Horizon 会重绘商品区，预览开过的话重新挂回去 */
    new MutationObserver(function () { if (started && !wrap.isConnected) mount(); })
      .observe(document.body, { childList: true, subtree: true });
    /* 字体是异步加载的，加载完要重新量一次宽度 */
    if (document.fonts) { document.fonts.ready.then(draw); document.fonts.addEventListener('loadingdone', draw); }
    draw();
  }

  /* 推荐写法小按钮（所有饼干商品通用，和预览无关）
     推荐写法写在 Loomina 定制项「提示」的最后：「… Ideen: A | B | C」。
     PatchStitch 不会同步文字定制项的 hint_text，所以借用提示字段；这里把「Ideen」那段从提示里拿掉，变成可点的按钮。
     PatchStitch 每次输入都会重建选项 DOM，所以用 MutationObserver 在绘制前重新处理（回调是微任务，提示原文不会闪出来） */
  var IDEAS = /\s*(?:Ideen|Id[ée]es)\s*:\s*(.+)$/i;
  function overrides() {
    var host = document.querySelector('[data-lf-bp]');
    var cfg = host && PRODUCTS[host.getAttribute('data-product-id')];
    return (cfg && cfg.ui) || {};
  }
  /* PatchStitch 自带的界面文字（上传框、报错）由 assets/lf-customization-upload.js 统一换成 locales 译文 */
  function ideas() {
    var root = document.querySelector('[data-patchstitch-root]');
    if (!root) return;
    var ui = overrides();
    root.querySelectorAll('.ps-option').forEach(function (opt) {
      var t = opt.querySelector('.ps-option__title');
      var title = norm(t && t.firstChild ? t.firstChild.textContent : '');
      var ov = null;
      Object.keys(ui).forEach(function (k) { if (!ov && title.indexOf(k) === 0) ov = ui[k]; });
      var tip = opt.querySelector('.ps-option__tooltip');
      var inp = opt.querySelector('.ps-text-input');
      if (!inp) return;
      /* 德语覆盖：只在内容不同时才写，避免触发自己的 MutationObserver 死循环 */
      if (ov && ov.ph && inp.placeholder !== ov.ph) inp.placeholder = ov.ph;
      var list = null;
      if (tip) {
        var m = tip.textContent.match(IDEAS);
        if (m) {
          var rest = tip.textContent.replace(IDEAS, '').trim();
          tip.setAttribute('data-lf-ideas', m[1]);
          tip.textContent = rest; tip.hidden = !rest;
        }
        if (ov && ov.tip && tip.textContent !== ov.tip) { tip.textContent = ov.tip; tip.hidden = false; }
        if (tip.hasAttribute('data-lf-ideas')) list = tip.getAttribute('data-lf-ideas').split('|');
      }
      if (ov && ov.ideas) list = ov.ideas;
      /* 产品元字段 liebefunk.text_ideas 写了这一项时，推荐按钮交给 assets/lf-text-ideas.js */
      if (window.LfTextIdeas && window.LfTextIdeas.has(title)) list = null;
      if (!list) return;
      var box = opt.querySelector('.lf-bp-chips');
      if (!box) {
        box = document.createElement('div'); box.className = 'lf-bp-chips'; box.setAttribute('aria-label', 'Ideen');
        list.map(function (c) { return c.trim(); }).filter(Boolean).forEach(function (c) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = c;
          b.addEventListener('click', function () {
            /* 点击时重新找输入框：PatchStitch 可能已经换了一个新的 */
            var o = b.closest('.ps-option'), i = o && o.querySelector('.ps-text-input'); if (!i) return;
            Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(i, c.slice(0, i.maxLength > 0 ? i.maxLength : c.length));
            i.dispatchEvent(new Event('input', { bubbles: true }));
          });
          box.appendChild(b);
        });
        (opt.querySelector('.ps-text-input-wrap') || inp).insertAdjacentElement('afterend', box);
      }
      box.querySelectorAll('button').forEach(function (b) {
        var on = String(b.textContent === inp.value);
        if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
      });
    });
  }

  function scan() {
    document.querySelectorAll('[data-lf-bp]').forEach(function (h) { if (!h.dataset.lfReady) { h.dataset.lfReady = '1'; boot(h); } });
    if (document.querySelector('[data-lf-bp]') && !scan.ideas) {
      scan.ideas = true;
      new MutationObserver(ideas).observe(document.body, { childList: true, subtree: true });
      ideas();
    }
  }
  /* 本地比对页用：按配置把默认文字画进指定画面 */
  window.LfBiscuitPreview = { products: PRODUCTS, filters: filters, scene: scene, stage: stage };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
